<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JYMK3t/tc-custom/9781488030017.jpg?1728327020067" alt="This image is the cover for the book Secret Bodyguard, Trueblood, Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Bodyguard, Trueblood, Texas
      </h1>
      <p class="bookDescription body article font2">
        <i>She may be the wrong girl, but this undercover cop will compromise everything he valuesto make things right for her and her daughter.</i><br/><br/> Amanda Crowe's baby girl has been kidnapped, and in the shadowy world in which she lives, there's no one to trust exceptherself. But she hasn't counted on Jesse McCall getting in her way—a man who is more thanhe seems…<br/><br/> Posing as Amanda's driver, undercover cop Jesse McCall is assigned to watch themobster's daughter. But he can't ignore Amanda's heart-wrenching effort to bring her childhome, nor her siren's call luring him ever closer. As a cop, Jesse has a duty to fulfill.But as Amanda's lover, he'll protect her and her baby from all harm—even if it meansbreaking the law. <br/><br/> Originally published in 2001
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B. J. Daniels
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author B.J. Daniels lives in Montana with her husband, Parker, and two springer spaniels. When not writing, she quilts, boats and always has a book or two to read. Contact her at <a href="http://www.bjdaniels.com/">www.bjdaniels.com</a>, on Facebook at B.J. Daniels or through her reader group the B.J. Daniels' Big Sky Darlings, and on twitter at bjdanielsauthor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6531842b